<script lang="ts">
  import { page } from "$app/state";

  type Tab = {
    href: string;
    name: string;
  };

  interface Props {
    tabs: Tab[];
    mxEdgeX?: boolean;
    ariaLabel?: string;
    class?: string;
    children?: import("svelte").Snippet;
  }

  let {
    tabs,
    mxEdgeX = false,
    ariaLabel = "Faner",
    class: classes = "",
    children,
  }: Props = $props();
  let currentTabIndex = $derived.by(() => {
    let indexLength = [0, 0];
    tabs
      .map(({ href }) => (page.url.pathname.match(href) || [""])[0])
      .forEach((match, i) => {
        if (match.length > indexLength[1]) indexLength = [i, match.length];
      });

    return indexLength[0];
  });
</script>

<!-- Tabs should be used in combination with layout, with routes corresponding to the hrefs in tabs[]-->

<nav class="flex gap-[.5ch] text-body pr-[1rem] laptop:text-lead" aria-label={ariaLabel}>
  {#each tabs as tab, i (tab)}
    <a
      data-sveltekit-noscroll
      class="button bg-transparent min-w-0 whitespace-nowrap"
      class:current-tab={i === currentTabIndex}
      aria-current={page.url.pathname === tab.href.split("?")[0] ? "page" : undefined}
      href={tab.href}>{tab.name}</a
    >
  {/each}
</nav>

<div
  class="tabs-component-content py-4 {classes} {mxEdgeX ? `not-full-width` : ''}"
  class:mx-edge-x={mxEdgeX}
>
  {@render children?.()}
</div>

<style lang="postcss">
  :global(:where(.tabs-component-content)) {
    --_shadow-top: 0 -1px;
    --_shadow-bottom: 0 1px;
    background-color: var(--primary-white);
    padding-block-end: var(--s-4);
    margin-inline: auto;
    box-shadow: var(--_shadow-top), var(--_shadow-bottom);
  }

  .tabs-component-content.not-full-width {
    border-radius: 0 1rem 1rem 1rem;
    box-shadow:
      var(--_shadow-top, 0 -1px),
      var(--_shadow-bottom, 0 1px),
      inset 1px 0,
      inset -1px 0;
    padding-inline: var(--s-3);
  }

  @media (--tablet) {
    .tabs-component-content.not-full-width {
      padding: var(--s-5) var(--s-7);
    }
  }

  .button {
    border-radius: 1rem 1rem 0 0;
    border-bottom: 0;
  }

  .button.current-tab {
    background-color: var(--primary-white);
  }
  nav {
    overflow-x: auto;
    margin-inline-start: var(--space-edge-x);
  }
</style>
